import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import axiosInstance from "../../../configs/axios/axios ";
import { GET_REPORTS_LIST } from "../../../configs/axios/constantsAPI";
import { getCookie } from "../../../configs/cookie-helper/cookieHelper";

export const getReportsListAction = createAsyncThunk(
  "reports/getReportsListAction",
  async (sendData: any, { rejectWithValue, getState }: any) => {
    let token = getCookie("token") as string;
    try {
      const { data } = await axiosInstance.post(
        GET_REPORTS_LIST,
        JSON.stringify(sendData),
        {
          headers: {
            token: token ? token : getState().authenticationState.token,
          },
        }
      );
      return data;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export interface Items {
  id: string;
  uniq_id: string;
  name: string;
  ip: string;
  link: string;
  nameShareFile: string;
  download: string;
  status: string;
  timestamp: string;
}

export interface ReportsState {
  reportsData: {
    actionStatus: string;
    alert: {
      error: boolean;
      message: string;
    };
    list: Array<Items>;
  };

  filtersReports: {
    name: string;
    ip: string;
    date: string;
  };
}

const initialState: ReportsState = {
  reportsData: {
    actionStatus: "",
    alert: {
      error: false,
      message: "",
    },
    list: [],
  },

  filtersReports: {
    name: "",
    ip: "",
    date: "",
  },
};

export const reportsSlice = createSlice({
  name: "reports",
  initialState,
  reducers: {
    setFiltersReportsAction: (
      state,
      action: PayloadAction<{
        name: string;
        ip: string;
        date: string;
      }>
    ) => {
      state.filtersReports = action.payload;
    },
  },
  extraReducers: ({ addCase }) => {
    addCase(getReportsListAction.pending, (state) => {
      state.reportsData.actionStatus = "loading";
      state.reportsData.alert = {
        error: false,
        message: "",
      };
    });
    addCase(getReportsListAction.fulfilled, (state, { payload }) => {
      state.reportsData.actionStatus = "success";
      state.reportsData.alert = {
        error: payload.content?.error,
        message: payload.content?.error
          ? payload.content?.message === "login_again"
            ? "login_again"
            : payload.content?.message
          : "Great, we didn't encounter any errors!",
      };
      state.reportsData.list = payload.content?.data;
    });
    addCase(getReportsListAction.rejected, (state, { payload }: any) => {
      state.reportsData.actionStatus = "rejected";
      state.reportsData.alert = {
        error: payload.content?.error,
        message: payload.content?.error
          ? "Sorry, we encountered an error!"
          : "Great, we didn't encounter any errors!",
      };
    });
  },
});

export const { setFiltersReportsAction } = reportsSlice.actions;

export const reports = (state: RootState) => state.reportsState;

export default reportsSlice.reducer;
